import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import StoreHeader from "@/components/store/StoreHeader";
import HeroLanding from "@/components/store/HeroLanding";
import ProblemStore from "@/components/store/ProblemStore";
import WhyPogo from "@/components/store/WhyPogo";
import EasySteps from "@/components/store/EasySteps";
import FaqStore from "@/components/store/FaqStore";
import FinalClose from "@/components/store/FinalClose";
import StickyBuyBar from "@/components/store/StickyBuyBar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { trackPageView } from "@/lib/meta";
import { countStoredCart } from "@/lib/cartStorage";

// POGO preorder LANDING page — rebuilt from scratch (blank-canvas layouts,
// brand identity preserved). Persuasion only: zero purchase controls, every
// CTA routes to /product. `angle` swaps the hero message for Meta ad
// variants (config/lander.js).
export default function HomePage({ angle = "long-shift" }) {
  const { hash } = useLocation();

  useEffect(() => {
    trackPageView("/");
    // Support cross-page anchor links (/#why, /#faq from the product page).
    if (hash) {
      setTimeout(
        () =>
          document
            .getElementById(hash.slice(1))
            ?.scrollIntoView({ behavior: "smooth" }),
        300
      );
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div data-testid="home-page" className="bg-ivory text-ink font-body">
      <Seo
        title="POSSO — Work Clogs That Don't Look Like Work Shoes"
        description="Slip-resistant, closed-toe work clogs in real colour, made for long shifts. Pink and Black available to preorder now — $119 with free Australia-wide shipping."
        path="/"
      />
      <StoreHeader cartCount={countStoredCart()} />
      <main>
        <HeroLanding angle={angle} />
        <WhyPogo />
        <ProblemStore />
        <EasySteps />
        <FaqStore />
        <FinalClose />
      </main>
      <Footer />
      <StickyBuyBar />
    </div>
  );
}
